import { Component } from 'preact'
import { getIdAndContentTypeFromTopics, UnifiedTopic } from '../../utils'
import PermanentlyDeleteModal from './PermanentlyDeleteModal'
import { permanentlyDeleteSpamPosts } from './service'
// eslint-disable-next-line import/no-internal-modules
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import Button from '@insided/control/uikit/Button'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'

interface State {
  isModalOpen: boolean
}

class PermanentlyDelete extends Component<BulkActionComponentProps, State> {
  state = {
    isModalOpen: false
  }

  render() {
    const { numberOfSelectedItems, performBulkAction } = this.props
    const { isModalOpen } = this.state
    return (
      <div>
        <Button
          title={
            <div>
              <Icon icon='trash' width={16} height={16} />
              Delete permanently
            </div>
          }
          size='medium'
          variant='warning'
          className='qa-permanently-delete-spam'
          onClick={() => this.setState({ isModalOpen: true })}
        />
        <PermanentlyDeleteModal
          numberOfSelectedItems={numberOfSelectedItems}
          isOpen={isModalOpen}
          permanentlyDelete={() =>
            performBulkAction({
              onClick: async (topics: UnifiedTopic[]) => {
                return await permanentlyDeleteSpamPosts(getIdAndContentTypeFromTopics(topics))
              },
              successMessage: numberOfSelectedItems > 1 ? `You’ve deleted ${numberOfSelectedItems} posts permanently.` : 'You’ve deleted this post permanently.'
            })}
          onClose={() => this.setState({ isModalOpen: false })}
        />
      </div>
    )
  }
}

export default PermanentlyDelete
